import React from "react";
import { trackEvent } from "./analytics";
import { BILLING_INTERVALS } from "./pricing";

function BillingIntervalSelector({
  value,
  onChange,
  labels,
  saveLabel,
  className = "",
  disabled = false,
}) {
  const selected = value === BILLING_INTERVALS.MONTHLY
    ? BILLING_INTERVALS.MONTHLY
    : BILLING_INTERVALS.ANNUAL;
  const handleChange = (billingInterval) => {
    trackEvent("billing_interval_select", { billing_interval: billingInterval });
    onChange(billingInterval);
  };

  return (
    <div
      className={`billing-interval-toggle ${className}`.trim()}
      role="group"
      aria-label={labels.ariaLabel}
    >
      <button
        type="button"
        className={`billing-interval-toggle__option ${selected === BILLING_INTERVALS.MONTHLY ? "is-active" : ""}`}
        aria-pressed={selected === BILLING_INTERVALS.MONTHLY}
        disabled={disabled}
        onClick={() => handleChange(BILLING_INTERVALS.MONTHLY)}
      >
        {labels.monthly}
      </button>
      <button
        type="button"
        className={`billing-interval-toggle__option ${selected === BILLING_INTERVALS.ANNUAL ? "is-active" : ""}`}
        aria-pressed={selected === BILLING_INTERVALS.ANNUAL}
        disabled={disabled}
        onClick={() => handleChange(BILLING_INTERVALS.ANNUAL)}
      >
        <span>{labels.annual}</span>
        <span className="billing-interval-toggle__save">{saveLabel}</span>
      </button>
    </div>
  );
}

export default BillingIntervalSelector;
